import React from 'react'
import { Box, SxProps, SxStyleProp } from 'rebass'
import { StoryCard, IStoryCardProps } from './StoryCard'
import { containerStyles } from './StoryCardList.styles'

export interface IStoryCardListProps {
  storyCards: IStoryCardProps[]
  sx?: SxProps | SxStyleProp
}

export const StoryCardList = ({ storyCards, sx = {} }: IStoryCardListProps) => {
  return (
    <Box sx={{ ...containerStyles, ...sx }}>
      {storyCards.map((storyCard, index) => (
        <StoryCard key={`story-card-${index}`} {...storyCard} />
      ))}
    </Box>
  )
}
